import { io, Socket } from 'socket.io-client'

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3002'

let socket: Socket | null = null

export function getOrderSocket(): Socket {
  if (!socket) {
    socket = io(`${API_BASE}/restaurant-orders`, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
    })
  }
  return socket
}

export function joinRestaurantOrders(restaurantId: string, onUpdate: (payload: unknown) => void) {
  const s = getOrderSocket()
  const handler = (payload: unknown) => onUpdate(payload)
  s.emit('join-restaurant', { restaurantId })
  s.on('order-updated', handler)
  return () => {
    s.off('order-updated', handler)
  }
}
